module.exports = "<app-object-viewer title=\"State\" [value]=\"state\"></app-object-viewer>"